(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('OBRA_MUSEO_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<obra-museo-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                '></obra-museo-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (ObraMuseo) {
                        return new ObraMuseo();
                    }
                }
            }
        });
})();
